<div [hidden]="isEmbeddedPageOpen">
    <h2>{{ 'services_real_server_configuration' | myLbTranslate }}</h2>
    <form [formGroup]="serviceForm" [loaded]="!wizardService.isLoading">
        <div [formGroupName]="subStepEnum.GENERAL">
            <h2>{{ subStepEnum.GENERAL | myLbTranslate }}</h2>
            <section data-control-name="name">
                <div *ngIf="!isInputHidden('name')" class="form-group">
                    <label for="domain{{templateIndex}}">{{ 'name' | myLbTranslate }}*</label>
                    <div class="form-content">
                        <ng-container *ngIf="namePrefix">
                            <span class="name-prefix">{{ namePrefix }}</span>
                        </ng-container>
                        <input
                            id="name{{templateIndex}}"
                            formControlName="name"
                            name="name"
                            title="name"
                            type="text">
                        <app-validation-messages [control]="serviceForm.get(subStepEnum.GENERAL + '.name')">
                        </app-validation-messages>
                        <app-help class="help-button" tag="members_name"></app-help>
                    </div>
                </div>
            </section>
            <section data-control-name="ip">
                <div *ngIf="!isInputHidden('ip')" class="form-group">
                    <label for="ip{{templateIndex}}">{{ 'ip' | myLbTranslate }}*</label>
                    <div class="form-content">
                        <input
                            formControlName="ip"
                            id="ip{{templateIndex}}"
                            name="ip"
                            type="text">
                        <app-validation-messages [control]="serviceForm.get(subStepEnum.GENERAL + '.ip')">
                        </app-validation-messages>
                        <app-help class="help-button" tag="members_ip"></app-help>
                    </div>
                </div>
            </section>
            <section data-control-name="monitorIp">
                <div *ngIf="!isInputHidden('monitorIp')" class="form-group">
                    <label for="monitorIp{{templateIndex}}">{{ 'gslb_healthcheck_ip' | myLbTranslate }}*</label>
                    <div class="form-content">
                        <input
                            formControlName="monitorIp"
                            id="monitorIp"
                            name="monitorIp"
                            type="text">
                        <app-validation-messages [control]="serviceForm.get(subStepEnum.GENERAL + '.monitorIp')">
                        </app-validation-messages>
                        <app-help class="help-button" tag="members_monitor-ip"></app-help>
                    </div>
                </div>
            </section>
            <section data-control-name="monitorIp">
                <div *ngIf="!isInputHidden('weight')" class="form-group">
                    <label for="members-weight{{templateIndex}}">{{ 'weight' | myLbTranslate }}*</label>
                    <div class="form-content">
                        <app-dropdown
                            dropDownId="members-weight{{templateIndex}}"
                            formControlName="weight"
                            [formGroup]="getFormGroup(subStepEnum.GENERAL)"
                            [content]="dropdown.membersWeight">
                        </app-dropdown>
                        <app-validation-messages [control]="serviceForm.get(subStepEnum.GENERAL + '.weight')">
                        </app-validation-messages>
                        <app-help class="help-button" tag="members_weight"></app-help>
                    </div>
                </div>
            </section>

            <section *ngIf="!isInputHidden('regions')" data-control-name="regions">
                <label for="region{{templateIndex}}">{{ 'regions' | myLbTranslate }}</label>
                <div class="form-group" *ngFor="let control of regionRows.controls; index as i" formArrayName="regions">
                    <div class="form-content" [formGroupName]="i.toString()">
                        <app-dropdown
                            dropDownId="region-{{templateIndex}}-{{i}}"
                            [dropdownWidth]="250"
                            [formGroup]="serviceForm?.get(subStepEnum.GENERAL + '.regions')['controls'][i]"
                            formControlName="id"
                            [content]="dropdown.regions"
                            [hiddenContentKeys]="realServerDropdownHiddenKeys"
                            [alwaysShowStartText]="true"
                            (keyOut)="updateRegions($event, i)">
                        </app-dropdown>
                        <button
                            [disabled]="regionRows.length === 1"
                            class="button-as-link"
                            (click)="removeRegion(i)">
                            {{ 'delete' | myLbTranslate }}
                        </button>
                        <button
                            [disabled]="!serviceForm.get(subStepEnum.GENERAL + '.regions').valid"
                            class="button-as-link"
                            (click)="addRegion()">
                            {{ 'add_another' | myLbTranslate }}
                        </button>
                    </div>
                </div>
            </section>
            <button class=primary (click)="setUpEmbeddedComponent()">{{ 'region_add_new' | myLbTranslate }}</button>
        </div>
    </form>
</div>
<div *ngIf="!isAddEdit" class="component-footer embedded">
    <button
        id="real-server-cancel"
        class="outline"
        (click)="returnToParentPage()">
        {{ 'cancel' | myLbTranslate }}
    </button>
    <button
        id="real-server-add"
        class="primary"
        [disabled]="serviceForm.invalid || serviceForm.pristine"
        (click)="returnToParentPage(serviceForm.get(subStepEnum.GENERAL).value)">
        {{ 'add' | myLbTranslate }}
    </button>
</div>


<ng-container #regionsContainer></ng-container>
